/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiScreeningTest,
    ApiScreeningTestFromJSON,
    ApiScreeningTestToJSON,
} from '../models';

export interface CancelScreeningTestRequest {
    id: number;
}

export interface CreateScreeningTestRequest {
    apiScreeningTest: ApiScreeningTest;
}

export interface DeleteScreeningTestsRequest {
    createdBefore?: Date;
}

export interface ScheduleScreeningTestRequest {
    id: number;
}

/**
 * 
 */
export class ScreeningTestApi extends runtime.BaseAPI {

    /**
     */
    async cancelScreeningTestRaw(requestParameters: CancelScreeningTestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cancelScreeningTest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-tests/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelScreeningTest(requestParameters: CancelScreeningTestRequest, initOverrides?: RequestInit): Promise<void> {
        await this.cancelScreeningTestRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createScreeningTestRaw(requestParameters: CreateScreeningTestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiScreeningTest>> {
        if (requestParameters.apiScreeningTest === null || requestParameters.apiScreeningTest === undefined) {
            throw new runtime.RequiredError('apiScreeningTest','Required parameter requestParameters.apiScreeningTest was null or undefined when calling createScreeningTest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-tests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiScreeningTestToJSON(requestParameters.apiScreeningTest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiScreeningTestFromJSON(jsonValue));
    }

    /**
     */
    async createScreeningTest(requestParameters: CreateScreeningTestRequest, initOverrides?: RequestInit): Promise<ApiScreeningTest> {
        const response = await this.createScreeningTestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteScreeningTestsRaw(requestParameters: DeleteScreeningTestsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.createdBefore !== undefined) {
            queryParameters['createdBefore'] = (requestParameters.createdBefore as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-tests`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScreeningTests(requestParameters: DeleteScreeningTestsRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.deleteScreeningTestsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async findScreeningTestsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScreeningTest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-tests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScreeningTestFromJSON));
    }

    /**
     */
    async findScreeningTests(initOverrides?: RequestInit): Promise<Array<ApiScreeningTest>> {
        const response = await this.findScreeningTestsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async scheduleScreeningTestRaw(requestParameters: ScheduleScreeningTestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling scheduleScreeningTest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening-tests/{id}/schedule`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async scheduleScreeningTest(requestParameters: ScheduleScreeningTestRequest, initOverrides?: RequestInit): Promise<void> {
        await this.scheduleScreeningTestRaw(requestParameters, initOverrides);
    }

}
